const components = {
    // Global Elements
    // 'select-input': require('./components/Elements/Select.vue').default, // Instead.. use 'select-c'
    'select-c': require('./components/Elements/SelectC.vue').default,
    'price-input': require('./components/PriceInput.vue').default,
    'alert-box': require('./components/Elements/AlertBox.vue').default,
    'spinner': require('./components/Elements/Spinner.vue').default,
    'flash-message': require('./components/FlashMessage.vue').default,
    'modal': require('./components/Modal.vue').default,
    'draggable-modal': require('./components/Elements/DraggableModal.vue').default,
    'v-menu': require('./components/Menu.vue').default,
    'v-mobile-menu': require('./components/MobileMenu.vue').default,
    'button-group': require('./components/ButtonGroup.vue').default,
    'text-alerts': require('./components/TextAlert.vue').default,
    'video-modal-button': require('./components/VideoModalButton.vue').default,
    'cttp-modal': require('./components/CTTPModal.vue').default,
    'cc-expired-modal': require('./components/CreditCardExpiredModal.vue').default,
    'cc-payment-failed-modal': require('./components/CreditCardPaymentFailedModal.vue').default,
    'tabs': require('./components/Elements/Tabs/Tabs.vue').default,
    'tab': require('./components/Elements/Tabs/Tab.vue').default,

    // 'create-or-pick-item': require('./components/CreateOrPickItem.vue').default, //!!!! NOT USED (used in Options/Search.vue)

    // Selectors
    'commodity-selector': require('./components/Selectors/CommoditySelector.vue').default,
    'option-selector-2': require('./components/Selectors/OptionsV2.vue').default,
    'option-type-selector': require('./components/Selectors/OptionTypeSelector.vue').default,
    'contract-selector': require('./components/Selectors/ContractSelector.vue').default,
    'forex-selector': require('./components/Selectors/Forex.vue').default,
    'spread-selector': require('./components/Selectors/SpreadSelector.vue').default,
    'stock-search-selector': require('./components/Selectors/StockSelector.vue').default,
    'chart-book-selector': require('./components/Selectors/ChartBook.vue').default,
    'chart-symbol-selector': require('./components/Chart/ChartSymbolSelector.vue').default,

    // Forms
    'contact-us-form': require('./components/ContactUsForm.vue').default,
    // 'seminar-form': require('./components/SeminarForm.vue').default, //!!!! NOT USED
    'order-form': require('./components/OrderForm.vue').default,
    'login-modal': require('./components/LoginModal.vue').default,
    'profile-form': require('./components/ProfileForm.vue').default,
    'notification-form': require('./components/NotificationForm.vue').default,
    // 'notification-form-v1': require('./components/NotificationFormV1.vue').default,
    'feedback-modal': require('./components/FeedbackModal.vue').default,
    'survey-form': require('./components/SurveyForm.vue').default,
    'affiliate-modal': require('./components/AffiliateModal.vue').default,
    'free-report-form': require('./components/FreeReportForm.vue').default,

    // Data Table
    'data-table': require('./components/DataTable/DataTable.vue').default,
    'data-table-row': require('./components/DataTable/DataTableRow.vue').default,
    'dt-flip-charts-button': require('./components/DataTable/FlipChartsButton.vue').default,
    'dt-commodity-navigation': require('./components/DataTable/CommodityNavigation.vue').default,
    'dt-timeframe-select': require('./components/DataTable/TimeframeSelect.vue').default,
    'dt-period-select': require('./components/DataTable/PeriodSelect.vue').default,
    'dt-request-select': require('./components/DataTable/RequestSelect.vue').default,
    'dt-sort-by': require('./components/DataTable/SortBy.vue').default,
    'dt-export': require('./components/DataTable/ExportToCSV.vue').default,
    'dt-show-triggered-markets': require('./components/DataTable/ShowTriggeredMarkets.vue').default,

    'chart': require('./components/Chart.vue').default,
    'grid-chart-view': require('./components/Chart/GridChartView.vue').default,
    'related-select': require('./components/Chart/RelatedSelect.vue').default,

    // Page specific
    'spread-quotes': require('./components/SpreadQuotes.vue').default,
    'futures-quotes': require('./components/FuturesQuotes.vue').default,
    'option-quotes': require('./components/OptionQuotes.vue').default,
    // 'option-search': require('./components/Options/Search.vue').default, //!!!! NOT USED
    'option-calculator': require('./components/Options/Calculator.vue').default,
    'option-info-block': require('./components/OptionInfoBlock.vue').default,
    'option-history': require('./components/OptionHistory.vue').default,

    // My Folder
    'trade-tracker': require('./components/MyFolder/TradeTracker.vue').default,
    'custom-quotes': require('./components/MyFolder/CustomQuotes.vue').default,
    'custom-quotes-form': require('./components/MyFolder/CustomQuotes/CustomQuotesForm.vue').default,
    'my-chart-book': require('./components/MyFolder/MyChartBook.vue').default,
    'order-tickets': require('./components/MyFolder/OrderTickets.vue').default,
    'order-tickets-group': require('./components/MyFolder/OrderTickets/OrderTicketsGroup.vue').default,
    'order-tickets-form': require('./components/MyFolder/OrderTickets/OrderTicketsForm.vue').default,
    'shared-charts': require('./components/MyFolder/SharedCharts.vue').default,
    'price-alerts': require('./components/MyFolder/PriceAlerts.vue').default,
    'chart-templates': require('./components/MyFolder/ChartTemplates.vue').default,

    // Jim's Desk
    'cheat-sheet': require('./components/JimsDesk/CheatSheet.vue').default,
    'jims-trade-tracker': require('./components/JimsDesk/JimsTradeTracker.vue').default,
    'turning-point-indicator': require('./components/JimsDesk/TurningPointIndicator.vue').default,
    'cttp': require('./components/JimsDesk/CTTP.vue').default,

    'flip-charts': require('./components/FlipCharts.vue').default,
    'mini-chart-widget': require('./components/MiniChartWidget.vue').default,
    'heat-map': require('./components/HeatMap.vue').default,
    'performance-leaders': require('./components/PerformanceLeaders.vue').default,
    'highs-lows-header': require('./components/HighsLowsHeader.vue').default,

    'video-vuetable': require('./components/VideoVuetable.vue').default,
    'video-modal': require('./components/VideoModal.vue').default,
    'documents-vuetable': require('./components/DocumentsVuetable.vue').default,

    // Admin
    'autocomplete': require('./components/Admin/Autocomplete.vue').default,
    'newsletter-form': require('./components/Admin/Newsletter.vue').default,
    'testimonials-form': require('./components/Admin/TestimonialsForm.vue').default,
    'homepage-form': require('./components/Admin/HomepageForm.vue').default,
    'binary-options-form': require('./components/Admin/BinaryOptionsForm.vue').default,
    'binary-options-vol-2-form': require('./components/Admin/BinaryOptionsVol2Form.vue').default,
    'admin-trade-tracker': require('./components/Admin/JimsTradeTracker.vue').default,
    'admin-trade-tracker-list': require('./components/Admin/JimsTradeTracker/JimsTradeTrackerList.vue').default,
    'admin-trade-tracker-categories': require('./components/Admin/JimsTradeTracker/JimsTradeTrackerCategories.vue').default,
    'admin-trade-tracker-notes': require('./components/Admin/JimsTradeTracker/JimsTradeTrackerNotes.vue').default,
    'admin-video-tags': require('./components/Admin/VideoTags.vue').default,
    'admin-product-select': require('./components/Admin/ProductSelect.vue').default,
    'cttp-form': require('./components/Admin/CTTPForm.vue').default,
    'promotions-report': require('./components/Admin/PromotionsReport.vue').default,
    'admin-product-form': require('./components/Admin/ProductForm.vue').default,
    'admin-email-update': require('./components/Admin/EmailUpdate.vue').default,

    'w-editor': require('./components/Admin/WEditor.vue').default,
};

/**
 * @typedef {Object} ComponentsMap
 * @property {import('components')} components
 */

export default {
    components: components,

    /**
    * Registers components
    * @param {import('vue').App} app
    */
    register(app) {
        Object.keys(this.components).forEach(name => {
            app.component(name, this.components[name])
        })

        // Admin async components
        // app.component('html-editor', () => import('./components/Admin/HtmlEditor.vue' /* webpackChunkName: 'admin-html-editor' */))
        // app.component('wysiwyg-editor', () => import('./components/WysiwygEditor.vue' /* webpackChunkName: 'wysiwyg-editor' */))
    }
}

// import { defineAsyncComponent } from 'vue'
// /**
//  * @typedef {Object} ComponentsMap
//  * @property {import('components').DefineAsyncComponent} Components
//  */

// /** @type {ComponentsMap} */
// export default {
//     components: {
//         'flash-message': defineAsyncComponent(() => import('./components/FlashMessage.vue')),
//     },

//     /**
//     * Registers components
//     * @param {import('vue').App} app
//     */
//     register(app) {
//         Object.keys(this.components).forEach(name => {
//             const asyncComponent = this.components[name]
//             app.component(name, asyncComponent)
//         })
//     }
// }
